import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";
import { COUNTRIES } from "../../../../data/constants";
import Modal from "../../shared/components/Modal";
import SelectWrapper from "../../shared/components/SelectWrapper";

/**
 * AddOrderModal
 *
 * Props:
 *   form                  { orderId, supplier, country, city }
 *   setForm               (updater) => void
 *   availableOrderOptions order[]   — orders that don't yet have a QC record
 *   saving                bool
 *   onOrderSelect         (orderNumber) => void   — handles autofill
 *   onSave                () => void
 *   onClose               () => void
 */
const AddOrderModal = React.memo(function AddOrderModal({
  form,
  setForm,
  availableOrderOptions,
  saving,
  onOrderSelect,
  onSave,
  onClose,
}) {
  return (
    <Modal title="New QC Order" onClose={onClose} maxWidth={440}>
      <div className={styles.formInner}>
        <div>
          <span
            className={styles.toggleLabelText}
            style={{ display: "block", marginBottom: 4, fontSize: 10 }}
          >
            Order ID *
          </span>
          <SelectWrapper
            value={form.orderId}
            onChange={(e) => onOrderSelect(e.target.value)}
          >
            <option value="">— Select Order —</option>
            {availableOrderOptions.map((o) => (
              <option key={o.id} value={o.orderNumber}>
                {o.orderNumber}
                {o._ownerName ? ` — ${o._ownerName}` : ""}
              </option>
            ))}
          </SelectWrapper>
        </div>

        <input
          className={styles.input}
          placeholder="Supplier * (autofilled from order)"
          value={form.supplier}
          onChange={(e) => setForm((f) => ({ ...f, supplier: e.target.value }))}
        />

        <div style={{ display: "flex", gap: 10 }}>
          <SelectWrapper
            value={form.country}
            wrapperClassName={styles.flex1}
            onChange={(e) =>
              setForm((f) => ({ ...f, country: e.target.value }))
            }
          >
            <option value="">— Country * —</option>
            {COUNTRIES.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </SelectWrapper>
          <input
            className={styles.input}
            style={{ flex: 1 }}
            placeholder="City"
            value={form.city}
            onChange={(e) => setForm((f) => ({ ...f, city: e.target.value }))}
          />
        </div>

        <button
          className={`${styles.btn} ${styles.btnPrimary}`}
          disabled={saving}
          onClick={onSave}
        >
          {saving ? "Saving…" : "Add Order"}
        </button>
      </div>
    </Modal>
  );
});

export default AddOrderModal;
